const globalTheme = (dir: string = 'ltr') => ({
  color: {
    blue: '#588AF0',
    blue7: '#588af012',
    gostBlue: '#EEF3FD',
    dark: {
      10: '#D8DBDF',
      20: '#D6DAEB',
      30: '#BCC1D7',
      80: '#1F2C51',
    },
    success: '#55BE9B',
    success10: 'rgba(96, 192, 142, 0.32)',
    gostSuccess: '#ECF5F1',
    error: '#E45555',
    gostError: 'rgba(235, 87, 87, 0.16)',
    error10: 'rgba(248, 88, 88, 0.39)',
    warn: '#FAB144',
    warn10: '#EBE0D0',
    white: '#fff',
    gray: {
      10: '#F0F0F3',
      20: '#F4F4F5',
      40: '#E5E5E9',
      60: '#9B9BA6',
      80: '#7A7A7A',
    },
    vip: '#7682B7',
    gold: '#D6BB8B',
    silver: 'Silver',
  },
  fs: {
    xxxs: '8px',
    xxs: '10px',
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    xxl: '22px',
    xxxl: '24px',
  },
  space: {
    right: dir === 'ltr' ? 'right' : 'left',
    left: dir === 'ltr' ? 'left' : 'right',
    xxs: '.25em', //1
    xs: '.5em', //2
    sm: '.75em', //3
    md: '1em', //4
    lg: '1.5em', //6
    xl: '2em', //8
    xxl: '2.5em', //10
    xxxl: '3em',
  },
  radius: {
    xs: '5px',
    sm: '8px',
    md: '10px',
    lg: '15px',
    xl: '20px',
    xxl: '30px',
    circle: '50%',
  },
  boxShadow: {
    sm: '0px 15px 50px rgba(160, 163, 189, 0.1)',
    md: '0px 2px 18px rgba(160, 163, 189, 0.25)',
  },
  dir,
});

const getTheme = (dir: string = 'ltr') => globalTheme(dir);

export default getTheme;
